import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=154b3d3a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=154b3d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b3d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154b3d3a')) {
      api.createRecord('154b3d3a', component.options)
    } else {
      api.reload('154b3d3a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=154b3d3a&scoped=true&", function () {
      api.rerender('154b3d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29boiMhVHujKi/JS/comp/GuestBox.vue"
export default component.exports